import React from "react";

import {
  Field,
  FieldHelper,
  FieldLabel,
  TwoColumnRow,
} from "../../../../components/FormPanel";
import { FormInput, SelectForm } from "../../../../components/Input";
import { CURRENCY_RULES, PAIR_ASSET_TYPE_OPTIONS } from "./constants";
import { NameField } from "./NameField";
import { SymbolField } from "./SymbolField";
import { PairFieldsProps } from "./types";

export const PairFields: React.FC<PairFieldsProps> = ({
  control,
  disabled,
  exchange,
}) => (
  <>
    <Field>
      <FieldLabel htmlFor="instrument-editor-pair-type">Asset type</FieldLabel>
      <SelectForm
        id="instrument-editor-pair-type"
        name="pairAssetType"
        control={control}
        options={PAIR_ASSET_TYPE_OPTIONS}
        disabled={disabled}
      />
      <FieldHelper>Exchange: {exchange}</FieldHelper>
    </Field>
    <TwoColumnRow>
      <SymbolField control={control} disabled={disabled} />
      <Field>
        <FieldLabel htmlFor="instrument-editor-currency">
          Quote currency
        </FieldLabel>
        <FormInput
          id="instrument-editor-currency"
          name="nativeCurrency"
          control={control}
          rules={CURRENCY_RULES}
          disabled={disabled}
        />
      </Field>
    </TwoColumnRow>
    <NameField control={control} disabled={disabled} />
  </>
);
